import deafultConfig from '../widgetConfigs'
import chartConfig from '../widgetConfigs/topicsStrengthsAndWeaknesses';
import moment from 'moment';
import CONST from '../constants'


export const convertToStackedDataForamat = (data, sortKey) => {
    if(sortKey == 'alphabet')
         data = arrayNameSort(data, 'topicDescription')
    if(sortKey == 'desc')
        data = sortDesc(data, 'topicOrderByPerfomance')
    if(sortKey == 'asce')
        data = sortAsc(data, 'topicOrderByPerfomance')


    let stackedData = {
       "categories": [{
        "category": [
        ]
      }],
      "dataset": []

    }

    let goodDataSet = {
          "seriesname": "Good",
          "color": deafultConfig.colorCodes.good,
          //"plotBorderThickness": "0",
            "showPlotBorder": "0",
             //"dashed":"1",
          "borderHoverDashed": "1",
           "borderHoverColor":  deafultConfig.colorCodes.good,
        "hoverColor":  deafultConfig.colorCodes.goodHover,

        "borderHoverDashLen": "6",
        "plotBorderDashLen": "6",
          "data": []
        };

    let badDataSet = {
        "seriesname": "Bad",
        "showPlotBorder": "1",
        "plotBorderColor": deafultConfig.colorCodes.badHover,

        "borderColor": deafultConfig.colorCodes.badHover,
        "borderHoverColor":  deafultConfig.colorCodes.bad,
        "hoverColor":  deafultConfig.colorCodes.badHover,

        "color": deafultConfig.colorCodes.bad,
        "data": []
    }

    let avgDataSet = {
          "seriesname": "avg",
          "color": deafultConfig.colorCodes.avg,
          "dashed":"1",
          "borderHoverDashed": "1",
           "borderHoverColor":  deafultConfig.colorCodes.avg,
        "hoverColor":  deafultConfig.colorCodes.avgHover,
        "borderHoverDashGap": "2",
         "borderHoverDashLen": "2",
          "borderDashLen": "2",

          "data": []
    }

    data.map(val =>{

      let good = 0, bad=0, avg = 0;

        val.questions.map(questionData => {
           if(questionData.mark == 'good'){
              good++
           }
           if(questionData.mark == 'low'){
             bad++
           }
           if(questionData.mark == 'avg'){
             avg++
           }
        })


        stackedData.categories[0].category.push({"label": val.topicDescription});
        goodDataSet.data.push({"value": good})
        badDataSet.data.push({"value": bad, "borderColor": "#db0020"})
        avgDataSet.data.push({"value": avg})

        stackedData.dataset = [badDataSet, avgDataSet, goodDataSet ]


    })


    return stackedData;

  }


export const arrayNameSort = (data, sortKey) => {
    data.sort( (a, b) => {
        return a[sortKey].localeCompare(b[sortKey]);
    });
    return data;
}

export const sortDesc = (data, sortKey) => {
    data.sort((a, b)=>  b[sortKey] - a[sortKey]);
    return data;
}

export const sortAsc = (data, sortKey) => {
    data.sort((a, b)=>  a[sortKey] - b[sortKey]);
    return data;
}
export const convertToBarDataForamat = (data, sortKey)=>{
  if (sortKey == 'question')
    data = sortAsc(data, 'questionOrder')
  if (sortKey == 'desc')
    data = sortDesc(data, 'percentage')
  if (sortKey == 'asc')
    data = sortAsc(data, 'percentage')

    let dataset=[];
    data.map(val => {
        dataset.push({ label: val.name, value: val.percentage});
    })
    return dataset;
}

export const getGroupedBarChartData = (data, sortKey) => {

    if (sortKey == 'alphabet')
      data = sortAsc(data, 'topicOrder')
    if (sortKey == 'desc')
      data = sortDesc(data, 'groupAverage')
    if (sortKey == 'asce')
      data = sortAsc(data, 'groupAverage')

    let chartDataset = [];

    //let barChartConfig = chartConfig.chartConfig;
    let barChartConfig = Object.assign({},chartConfig.chartConfig);

    data.map(val => {
      var question = (val.numberOfQuestion > 1) ? " questions" : " question";
      if (val.groupGrade.toLowerCase() == 'good') {
        let goodChartConfig = Object.assign({}, chartConfig.goodChartConfig);
        goodChartConfig.label = val.description
        goodChartConfig.value = val.groupAverage
        goodChartConfig.displayValue = val.numberOfQuestion + question
        chartDataset.push(goodChartConfig)
      }
      if (val.groupGrade.toLowerCase() == 'low') {
         let badChartConfig = Object.assign({}, chartConfig.badChartConfig);
        badChartConfig.label = val.description
        badChartConfig.value = val.groupAverage
        badChartConfig.displayValue = val.numberOfQuestion + question;
        chartDataset.push(badChartConfig)
      }
      if (val.groupGrade.toLowerCase() == 'average') {
        let avgChartConfig = Object.assign({}, chartConfig.avgChartConfig);
        avgChartConfig.label = val.description
        avgChartConfig.value = val.groupAverage
        avgChartConfig.displayValue = val.numberOfQuestion + question;
        chartDataset.push(avgChartConfig)
      }
    })
    barChartConfig.dataSource.data = chartDataset;
    return barChartConfig;
  }

export const convertToMsColumnForamat = (data) => {
  let dataset=[]
  let category=[];
  let rowData =[];

  let colorCode=[
    {
      color:'#a1e4df',
      hoverColor:'#00a396',
      plotBorderColor: '#00a396',
    },
    {
      color: '#bc52a7',
      hoverColor: '#820068',
      plotBorderColor: '#820068',
    },
    {
      color: '#f9e599',
      hoverColor: '#b38f00',
      plotBorderColor: '#b38f00',
    },
    {
      color: '#1bc0b3',
      hoverColor: '#008a7f',
      plotBorderColor: '#008a7f',
    },
    {
      color: '#f9c793',
      hoverColor: '#e27a0e',
      plotBorderColor: '#e27a0e',
    },
    {
      color: '#4a9de3',
      hoverColor: '#1a68a8',
      plotBorderColor: '#1a68a8',
    },
    {
      color: '#dfe1a5',
      hoverColor: '#94981b',
      plotBorderColor: '#94981b',
    }, 
    {
      color: '#f8c500',
      hoverColor: '#b38f00',
      plotBorderColor: '#b38f00',
    },
    {
      color: '#b6d7f3',
      hoverColor: '#3d97e1',
      plotBorderColor: '#3d97e1',
    },
    {
      color: '#b4ba21',
      hoverColor: '#7f8217',
      plotBorderColor: '#7f8217',
    },
    {
      color: '#e4b9db',
      hoverColor: '#bc52a7',
      plotBorderColor: '#bc52a7',
    },
    {
      color: '#fa8b19',
      hoverColor: '#cf6700',
      plotBorderColor: '#cf6700',
    }
  ]
  let chartdata = [];
  let indicativeGradeArr = [];
  let columDef = [
    {
      headerName: "Indicative grade",
      field: "indicativeGrade",
      sortable: true,
      unSortIcon: true,
      sortingOrder: ['asc'],
      minWidth: 150,
    }
  ];
  data.map((summary,i)=>{
    summary.results.map((res) => {

      let columnarray1 = {
        headerName: 'Number of students ' + res.groupName,
        field: 'numberOfStudents' + res.groupName,
        sortable: true,
        minWidth: 300,
        unSortIcon: true,
        sortingOrder: ['asc'],
        headerTooltip: 'Number of students ' + res.groupName
      }
      let columnarray2 = {
        headerName: 'Percentage ' + res.groupName,
        field: 'percentage' + res.groupName,
        sortable: true,
        minWidth: 250,
        unSortIcon: true,
        sortingOrder: ['asc'],
        headerTooltip: 'Percentage ' + res.groupName
      }
      columDef.push(columnarray1);
      columDef.push(columnarray2);
      chartdata[res.groupName] = [];
      let data = sortAsc(res.result, 'indicativeGrade')
      data.map((val) => {
        if (val.indicativeGrade != null) {
          indicativeGradeArr.push(val.indicativeGrade)
          chartdata[res.groupName][val.indicativeGrade] = { value: val.noOfStudents, displayValue: val.percentage + ' %' }   //exist line
        }
      })
      dataset.push({ 'seriesname': res.groupName, color: colorCode[i].color, hoverColor: colorCode[i].hoverColor, plotBorderColor: colorCode[i].plotBorderColor, 'data': [] });
    })
  })
  indicativeGradeArr = Array.from(new Set(indicativeGradeArr));
  indicativeGradeArr.sort(function (a, b) { return a - b });

  indicativeGradeArr.map((cat, i) => {
    category.push({ "label": cat.toString() });
  })

  dataset.map((val, key) => {
    indicativeGradeArr.map((cat, i) => {

      rowData[cat] = (typeof rowData[cat] != "undefined") ? { ...rowData[cat] } : {};

      rowData[cat]['indicativeGrade'] = cat;

      if (typeof chartdata[val.seriesname][cat] != 'undefined') {
        dataset[key]['data'][i] = chartdata[val.seriesname][cat]
        rowData[cat]['percentage' + val.seriesname] = chartdata[val.seriesname][cat].displayValue;
        rowData[cat]['numberOfStudents' + val.seriesname] = chartdata[val.seriesname][cat].value;

      } else {
        dataset[key]['data'][i] = { value:'0', displayValue: '0 %' }
        rowData[cat]['percentage' + val.seriesname] = '';
        rowData[cat]['numberOfStudents' + val.seriesname] = '';
      }
    })
  })
  let rowsArray=[];
  Object.keys(rowData).map((data)=>{
    rowsArray.push(rowData[data])
 })
  return { dataset: dataset, category: category, columDef: columDef, rowData: rowsArray }
}


export const getCurrentYear = () =>{
  let dateObj = new Date();
  return dateObj.getFullYear() - 1;

}


export const getChartHeight = data => {

  let resCount = (data)? data.length: 0;

  let heights = ['80', '80', '160']

  if(resCount < 3 )
    return heights[resCount];
  else{
      let chartHeight = ((resCount - 2) * 35)
      return 160 + chartHeight;
  }


}

export const formatDate = (dateString) => {
  
  let timestamp = moment(dateString);
  let date = timestamp.format("DD MMM YYYY");
  return date
}

export const formatDateUrl = (dateString) => {

  let timestamp = moment(dateString);
  let date = timestamp.format("YYYY-MM-DD");
  return date
}

export const tableDateFormatter = (params) => {

  var dateAsString = params.data.assessmentDate;
  var dateParts = dateAsString.split('-');
  let day = dateParts[2].slice(0, 2);
  let month = CONST.MONTHS[dateParts[1]];

  return `${day} ${month} ${dateParts[0]}`;

}

export const convertToColumnForamat = (data) => {  
  let dataset = [], average=''
  data.map((res) => {   
    dataset.push({
       label: (res.groupName != null)?res.groupName:"",
       value: (res.percentageOfStudents != null) ? res.percentageOfStudents:"0",
       displayValue: res.noOfStudentsAboveTrack + '/' + res.totalStudents
      })
    average = res.average;
  })

  return {dataset,average}
}

export const getUiUrl=()=>{
  return window.location.origin;
}

export const getUrlParamValuesAsObj = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    courseId: urlParams.get('courseId'),
    groupId: urlParams.get('groupId'),
    dateTaken: urlParams.get('dateTaken'),
    subjectId: urlParams.get('subjectId'),
    studentYear: urlParams.get('studentYear'),
    schoolId: urlParams.get('schoolId'),
    page: urlParams.get('page'),
    studentId: urlParams.get('studentId'),
    assessmentDate: urlParams.get('dateTaken'),
  }

}
export const sortDateDesc = (data, sortKey) => {
  data.sort((a, b) => new Date(b[sortKey]) - new Date(a[sortKey]));
  return data;
}

export const ShowCompare =(dataTaken)=>{
  let dateObj = new Date();
  let year = (dateObj.getFullYear());
  let currentYear = ((dateObj.getMonth()+1) > 8) ? year+1:year
  let priviousYear = ((dateObj.getMonth() + 1) > 8) ? year : year-1;
  let academicStart = priviousYear+'-09-01';
  let academicEnd = currentYear+'-08-31';
  if (academicStart <= dataTaken && academicEnd >= dataTaken){
    return true;
  }else{
    return false;
  } 
}

export const sortByKey = (array, key) => {
  return array.sort(function (a, b) {
    var x = a[key]; var y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}
